"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var translations_1 = require("../translations");
var reactStringReplace = require('react-string-replace');
var propTypes = {
    code: prop_types_1.default.string.isRequired,
    replaceOptions: prop_types_1.default.object,
    className: prop_types_1.default.string,
    TextComponent: prop_types_1.default.any,
    uppercase: prop_types_1.default.bool,
    escapeHTML: prop_types_1.default.bool,
    stripHTML: prop_types_1.default.bool
};
var LocaleString = /** @class */ (function (_super) {
    __extends(LocaleString, _super);
    function LocaleString() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stripSymbols = function (renderString) {
            var tag = /\$\{/g;
            var removeCurly = new RegExp('}', 'g');
            var returnString = renderString;
            returnString = returnString.replace(removeCurly, '');
            returnString = returnString.replace(tag, '');
            return returnString;
        };
        _this.replaceWithReactComponent = function (templateString, o) {
            function replaceKeys(match, key) {
                var component = o[key];
                var componentString = reactStringReplace(templateString, "$<" + key + ">", function () {
                    return component;
                });
                return componentString;
            }
            var strings = Object.keys(o).map(function (key) {
                return replaceKeys(templateString, key);
            }).flat();
            return strings;
        };
        _this.onLanguageChange = function () { return _this.forceUpdate(); };
        return _this;
    }
    LocaleString.prototype.componentDidMount = function () {
        translations_1.languageChangeEvent.on(this.onLanguageChange);
    };
    LocaleString.prototype.componentWillUnmount = function () {
        translations_1.languageChangeEvent.off(this.onLanguageChange);
    };
    LocaleString.prototype.render = function () {
        var _a = this.props, code = _a.code, _b = _a.escapeHTML, escapeHTML = _b === void 0 ? false : _b, replaceOptions = _a.replaceOptions, _c = _a.stripHTML, stripHTML = _c === void 0 ? false : _c, _d = _a.TextComponent, TextComponent = _d === void 0 ? 'span' : _d, _e = _a.uppercase, uppercase = _e === void 0 ? false : _e, props = __rest(_a, ["code", "escapeHTML", "replaceOptions", "stripHTML", "TextComponent", "uppercase"]);
        //seperate out the regular replacements with the jsx replacements
        var stringReplaceOptions = {};
        var jsxReplaceOptions = {};
        for (var property in replaceOptions) {
            if (typeof replaceOptions[property] === 'string' || typeof replaceOptions[property] === 'number') {
                stringReplaceOptions[property] = '' + replaceOptions[property];
            }
            else if (react_1.default.isValidElement(replaceOptions[property])) {
                jsxReplaceOptions[property] = replaceOptions[property];
            }
        }
        var translatedString = '';
        //do all the easy string replacements
        translatedString = translations_1.getString(code, stringReplaceOptions);
        //do all the jsx replacements
        var translatedStrings = [];
        if (Object.keys(jsxReplaceOptions).length) {
            translatedStrings = this.replaceWithReactComponent(translatedString, jsxReplaceOptions);
        }
        else {
            translatedStrings = [translatedString];
        }
        //and the rest
        var content = stripHTML ? translatedString.replace(/<(?:.|\n)*?>/gm, '') : translatedStrings;
        if (uppercase) {
            if (Array.isArray(content)) {
                content = content.map(function (item) { return item.toUpperCase(); });
            }
            else {
                content = content.toUpperCase();
            }
        }
        //give back the string
        return (escapeHTML || Object.keys(jsxReplaceOptions).length) ?
            react_1.default.createElement(TextComponent, __assign({ "data-sl-anchor": code, "data-key": code }, props), content)
            :
                react_1.default.createElement(TextComponent, __assign({ "data-sl-anchor": code, "data-key": code, dangerouslySetInnerHTML: { __html: content } }, props));
    };
    return LocaleString;
}(react_1.Component));
// @ts-ignore
LocaleString.propTypes = propTypes;
exports.default = LocaleString;
//# sourceMappingURL=locale-string.js.map